"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Context = React.createContext(null);
exports.AuthProvider = Context.Provider;
exports.AuthConsumer = Context.Consumer;
//# sourceMappingURL=AuthenticationContext.js.map